import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'contexts/AuthContext';

// Keeps non-instructor users out of the instructor portal (defense in
// depth — the API enforces this too via IsInstructor).
export default function InstructorGuard({ children }) {
  const { user } = useAuth();
  if (user && user.role !== 'instructor') return <Navigate to={APP_DEFAULT_PATH} replace />;
  return children;
}

InstructorGuard.propTypes = { children: PropTypes.node };
